import addRoute from '@/router/add-route';

const Organizations = () => import('@/modules/organizations/organizations.vue');
const OrganizationForm = () => import('@/modules/organizations/organization-form.vue');
const OrganizationDetails = () => import('@/modules/organizations/organization-details.vue');

const organizations = [
    addRoute({
        name: 'organizations',
        path: '/organizations',
        component: Organizations,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-organization',
        path: '/organizations/add',
        component: OrganizationForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'organization-details',
        path: '/organizations/:id',
        component: OrganizationDetails,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-organization',
        path: '/organizations/update/:id/',
        component: OrganizationForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default organizations;
